/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelDonationsResponse } from '../../models/travel-donations-response';

export interface TravelControllerGetTravelDonations$Params {
  id: number;
}

export function travelControllerGetTravelDonations(http: HttpClient, rootUrl: string, params: TravelControllerGetTravelDonations$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelDonationsResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerGetTravelDonations.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelDonationsResponse;
      }>;
    })
  );
}

travelControllerGetTravelDonations.PATH = '/travel/{id}/donations';
